import React, { useState, useEffect } from "react";
import Button from "@material-ui/core/Button";
import axios from "axios";
import "./Components/Style/Weather.css";

export default function Weather() {
  const [location, setLocation] = useState("India");
  const [temp, setTemp] = useState();
  const [icon, setIcon] = useState();
  const [wind, setWind] = useState();
  const [feel, setFeel] = useState();
  const [overall, setOverall] = useState();
  const [search, setSearch] = useState("");

  const getData = async () => {
    await axios
      .get(
        `https://api.openweathermap.org/data/2.5/weather?q=${location}&appid=c7644ec3f217e15f0a493f38d5f60120`
      )
      .then((Response) => {
        setTemp(Response.data.main.temp.toFixed(0));
        setIcon(Response.data.weather[0].icon);
        setWind(Response.data.wind.speed);
        setFeel((Response.data.main.feels_like - 273).toFixed(2));
        setOverall(Response.data.weather[0].main);
      })
      .catch((error) => console.log(error));
  };
  useEffect(() => {
    getData();
  }, [location]);

  function handleChange(event) {
    setSearch(event.target.value);
  }

  return (
    <div>
      <div className="weather-app-content">
        <div className="search-field">
          <h3>Search Weather...</h3>
        </div>
        <div className="search-box">
          <input
            type="text"
            placeholder={`Current ${location} temperature`}
            onChange={handleChange}
            required="true"
          />
        </div>
      </div>
      <div className="submit-btn">
        {search === "" ? (
          <Button onClick={() => setLocation(search)} disabled>
            Search
          </Button>
        ) : (
          <Button
            onClick={() => {
              setLocation(search);
              setSearch("");
            }}
          >
            Search
          </Button>
        )}
      </div>
      <div className="bottom-content">
        <div className="temperature">
          <div className="column-2">
            <img
              src={`https://openweathermap.org/img/wn/${icon}@2x.png`}
              alt="No-Icon"
              style={{ height: "6rem", width: "6rem" }}
            />
          </div>
          <div className="column2">
            <div className="celcious">
              <h1>{temp - 273}</h1>
            </div>
          </div>
          <div className="deg">
            <p>°C</p>
          </div>
        </div>
        <div className="temp-desc">
          <ul>
            <li>
              <strong>Wind: </strong> {wind}Km/h
            </li>
            <li>
              <strong>Feels Like: </strong> {feel}°C
            </li>
            <li>
              <strong>{overall}</strong>
            </li>
          </ul>
        </div>
      </div>
    </div>
  );
}
